import Avatar from 'react-avatar';
import { CurrentUserInformation } from '../../api/current-user';

export default function UserImage(props: { userData: CurrentUserInformation | undefined, imageSize: number }) {

	return (
		<div className='user-image'>
			{
				props.userData &&
				<Avatar
					src={props.userData.imageUrl}
					round={true}
					size={props.imageSize + 'px'}
					color='#E9E9E9'
    				fgColor='#575757'
					alt={props.userData.firstName + " " + props.userData.lastName}
					name={props.userData.firstName + " " + props.userData.lastName}
				>
				</Avatar>
			}
		</div >
	)
}
